// @ts-nocheck

const HIDDEN = 'HIDDEN';
const TEMPORARILY_VISIBLE = 'TEMPORARILY_VISIBLE';
const PINNED = 'PINNED';

export default {
  HIDDEN,
  TEMPORARILY_VISIBLE,
  PINNED,
};
